(function ($, SCS) {
	'use strict';

	SCS.Url = SCS.Url || {};

	/**
	 * Strips protocol from URL
	 * @method stripProtocolFromUrl
	 * @param {String} url
	 * @return {String} url
	 */
	SCS.Url.stripProtocolFromUrl = function(url) {
		if (url && url.length > 0) {
			return(url.replace(/^(https?\:)?\/\//ig, ''));
		}
	};

	/**
	 * Strips content/swisscom path prefixes from URL
	 * @method stripPathPrefixFromUrl
	 * @param {String} url
	 * @return {String} url
	 */
	SCS.Url.stripPathPrefixFromUrl = function(url) {
		if (url && url.length > 0) {
			return(url.replace(/\/content\/swisscom\//ig, '\/'));
		}
	};

	/**
	 * Add or update a query parameter in a URL.
	 *
	 * @method updateQueryStringParameter
	 * @param {String} uri - URL to update
	 * @param {String} key - name of parameter to add/update
	 * @param {String} value - value of parameter to add/update (note: has to be URLencoded!)
	 * @return {String} - URL with added/updated query parameter
	 */
	SCS.Url.updateQueryStringParameter = function (uri, key, value) {
		var re = new RegExp('([?|&])' + key + '=.*?(&|#|$)', 'i'),
			hash = '',
			separator;

		if (!uri) {
			return '';
		}
		else if (uri.match(re)) {
			return uri.replace(re, '$1' + key + '=' + value + '$2');
		}
		else {
			separator = uri.indexOf('?') !== -1 ? uri.indexOf('?') === uri.length - 1 ? '' : '&' : '?';
			if (uri.indexOf('#') !== -1) {
				hash = uri.replace(/.*#/, '#');
				uri = uri.replace(/#.*/, '');
			}
			return uri + separator + key + '=' + value + hash;
		}
	};

	/**
	 * Parse an URL into:
	 *	search:	'?foo=bar' or ''
	 *	hash:	'#foobar' or ''
	 */
	SCS.Url.parse = function (url) {
		var search = '',
			hash = '';

		if (typeof url === 'string') {
			// hash cannot contain #, %, ^, [, ], {, }, \, ", < and >
			var match = url.match(/(\?[^#]+)?(#[^#]+)?$/);
			if (match !== null) {
				search = match[1] || '';
				hash = match[2] || '';
			}
		}

		return {
			search: search,
			hash: hash
		};
	};

	/**
	 * @method parseHash
	 * @param url
	 * @returns {null}
	 */
	SCS.Url.parseHash = function (url) {
		var fragment,
			keyValues = null,
			hashValueFragments,
			hashValue;

		hashValue = SCS.Url.parse(url).hash.substring(1);
		if (hashValue !== '') {
			hashValueFragments = hashValue.split('&');
			keyValues = {};

			for (var i = 0, ii = hashValueFragments.length; i < ii; i += 1) {
				fragment = SCS.Url.parseKeyVal(hashValueFragments[i]);
				keyValues[fragment.key] = fragment.val;
				fragment = null;
			}
		}
		return keyValues;
	};

	/**
	 * queryKeyVal is a string with the following format "key=val" eg. "id=234"
	 *
	 * @method parseKeyVal
	 * @param queryKeyVal
	 */
	SCS.Url.parseKeyVal = function (queryKeyVal) {
		var fragments = queryKeyVal.split('=');

		if (fragments[1] === undefined) {
			fragments[1] = '';
		}

		return {
			'key': fragments[0],
			'val': fragments[1]
		};
	};

	SCS.Url.getValidSelector = function (selector) {
		if (!selector) {
			return '-';
		}

		var selectorCharacterMappings = {
			'ä': 'ae',
			'ö': 'oe',
			'ü': 'ue',
			'ß': 'ss',
			' ': '-',
			'é': 'e',
			'è': 'e',
			'à': 'a',
			'ù': 'u',
			'â': 'a',
			'ê': 'e',
			'î': 'i',
			'ô': 'o',
			'û': 'u',
			'ë': 'e',
			'ï': 'i',
			'ç': 'c',
			'ì': 'i',
			'í': 'i',
			'ò': 'o',
			'ó': 'o',
			'ú': 'u',
			'[^a-z0-9_\\-]': '-'
		};

		for (var expr in selectorCharacterMappings) {
			if (selectorCharacterMappings.hasOwnProperty(expr)) {
				selector = selector.replace(new RegExp(expr, 'gi'), selectorCharacterMappings[expr]);
			}
		}

		return selector;
	};

	// FIXME: It seems this is unused, remove
	SCS.Url.removeHost = function (url) {
		if (!url) {
			return '/';
		}

		url = url.replace(/http\:/, '').replace(/https\:/, '');
		if (url.indexOf('//') !== 0) {
			return url;
		}

		var parts = url.split('/');
		if (parts.length < 4) {
			return '/';
		}
		return '/' + parts.slice(3).join('/');
	};

	SCS.Url.removeHashParameter = require('lib/util/url').removeHashParameter;

}(window.$, window.SCS = window.SCS || {}));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.Url.js
// module id = 6
// module chunks = 0